module.exports = __webpack_public_path__ + "img/plus.ba8d05.svg";